import { createSvgIcon } from '@mui/material';

const TemplateShareIcon = (props) => {
  const { style, ...rest } = props;
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M12.25 3.5H10.3833C9.40324 3.5 8.9132 3.5 8.53885 3.69074C8.20957 3.85852 7.94185 4.12623 7.77407 4.45552C7.58333 4.82986 7.58333 5.31991 7.58333 6.3V7M12.25 3.5L10.5 1.75M12.25 3.5L10.5 5.25M5.83333 1.75H4.55C3.56991 1.75 3.07986 1.75 2.70552 1.94074C2.37623 2.10852 2.10852 2.37623 1.94074 2.70552C1.75 3.07986 1.75 3.56991 1.75 4.55V9.45C1.75 10.4301 1.75 10.9201 1.94074 11.2945C2.10852 11.6238 2.37623 11.8915 2.70552 12.0593C3.07986 12.25 3.56991 12.25 4.55 12.25H9.45C10.4301 12.25 10.9201 12.25 11.2945 12.0593C11.6238 11.8915 11.8915 11.6238 12.0593 11.2945C12.25 10.9201 12.25 10.4301 12.25 9.45V8.16667"
        stroke="currentColor"
        strokeOpacity="0.54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>,
    'TemplateShareIcon',
  );
  return (
    <IconCmp
      style={{ fill: 'none', ...style }}
      viewBox={'0 0 14 14'}
      {...rest}
    />
  );
};
export default TemplateShareIcon;
